import { ApiService } from 'react-angle-dashboard-components'
import { EmployeeDTO } from '../../interfaces/dto/employee'
import {
  EmployeeProfileForm,
  ModifyEmployee
} from '../../interfaces/views/employee'
import {
  mapDTOtoEditMemberForm,
  mapDToProfile,
  mapFormToD,
} from './mappers'



export class EmployeeService extends ApiService {
  async getEmployeeProfile(memberId: string) {
    const response: EmployeeDTO = await this.request({
      method: 'get',
      url: `/members/${memberId}`,
      credentials: true
    })
    return mapDToProfile(response)
  }

  async getEmployeeIdCard(memberId: string) {
    const response = await this.request({
      method: 'get',
      url: `/members/${memberId}`,
      credentials: true
    })
    return response
  }

  async getMemberForForm(memberId: string) {
    const response: EmployeeDTO = await this.request({
      method: 'get',
      url: `/members/${memberId}`,
      credentials: true
    })
    return mapDTOtoEditMemberForm(response)
  }

  async modifyEmployee(
    memberId: string,
    data: EmployeeProfileForm
  ): Promise<ModifyEmployee> {
    return this.request({
      method: 'patch',
      url: `/members/${memberId}`,
      credentials: true,
      data: mapFormToD(data)
    })
  }

}
